import { Formik } from 'formik';
import { Button, Group } from '@mantine/core';
import { MdClear, MdCancel, MdCheck } from 'react-icons/md';
import { FilterFormComponent } from './FilterFormComponent';
import { FilterFormSchema } from './FilterFormSchema';
import { useCodeRepositoriesFilter } from '../../hooks/useCodeRepositoriesFilter';

interface FilterFormProps {
    onApply: () => void;
    onCancel: () => void;
}

interface FilterFormValues {
    namePrefix?: string;
}

export const FilterForm = ({ onApply, onCancel }: FilterFormProps) => {
    const { filters, handleSetFilters, handleClearFilters } = useCodeRepositoriesFilter();

    const initialValues: FilterFormValues = {
        namePrefix: filters.namePrefix || '',
    };

    const onSubmit = (values: FilterFormValues) => {
        const cleanFilters = Object.entries(values).reduce((acc, [key, value]) => {
            if (value && value !== '') {
                acc[key] = value;
            }
            return acc;
        }, {} as any);

        handleSetFilters(cleanFilters);
        onApply();
    };

    const handleClear = () => {
        handleClearFilters();
    };

    return (
        <Formik<FilterFormValues>
            initialValues={initialValues}
            validationSchema={FilterFormSchema}
            onSubmit={onSubmit}
        >
            {({ handleSubmit, resetForm }) => (
                <>
                    <FilterFormComponent />

                    <Group justify="space-between" mt="xl">
                        <Button
                            variant="outline"
                            leftSection={<MdCancel />}
                            onClick={onCancel}
                        >
                            Cancel
                        </Button>
                        <Group gap="xs">
                            <Button
                                variant="outline"
                                leftSection={<MdClear />}
                                onClick={() => {
                                    resetForm();
                                    handleClear();
                                }}
                            >
                                Clear
                            </Button>
                            <Button
                                leftSection={<MdCheck />}
                                onClick={() => handleSubmit()}
                            >
                                Apply
                            </Button>
                        </Group>
                    </Group>
                </>
            )}
        </Formik>
    );
};
